'use client';

import { twMerge } from '@shared/themes';
import { useTranslations } from 'next-intl';
import type { ComponentProps } from 'react';
import { type TicketStatusInput, isHuntEndedByJackpotWin } from '../utils/getTicketStatuses/getTicketStatuses';

type AutoRenewalCancelledBannerProps = ComponentProps<'div'> &
  TicketStatusInput & {
    lastDrawingDate?: string;
  };

function getRenewalCancelledBannerDate(input: TicketStatusInput, lastDrawingDate?: string): string | undefined {
  if (isHuntEndedByJackpotWin(input)) return lastDrawingDate;

  return input.cancelReceiptAt;
}

function AutoRenewalCancelledBanner({ className, renewType, cancelReceiptAt, ticketState, lastDrawingDate, ...props }: AutoRenewalCancelledBannerProps) {
  const t = useTranslations('lotteries.ticket_details.auto_renewal_cancelled_banner');
  const ticketStatusInput = { renewType, cancelReceiptAt, ticketState };
  const bannerDate = getRenewalCancelledBannerDate(ticketStatusInput, lastDrawingDate)!;
  const isJackpotWonEnd = isHuntEndedByJackpotWin(ticketStatusInput);
  const date = new Date(bannerDate);

  return (
    <div
      className={twMerge('flex justify-between items-center bg-container-secondary rounded-md px-5 py-3 paragraph-s', className)}
      {...props}
      data-testid="auto-renewal-cancelled-banner"
    >
      {isJackpotWonEnd ? (
        <span data-testid="jackpot-won-message">{t('jackpot_won_message', { date })}</span>
      ) : (
        <>
          <span data-testid="cancelled-message">{t('message_text')}</span>
          <span data-testid="cancelled-date">{t('message_date', { date })}</span>
        </>
      )}
    </div>
  );
}

export { AutoRenewalCancelledBanner };
